import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { TicketService } from 'src/app/shared/services/ticket.service';
import {
  bookCustomTicketForEventUser,
  sportInvoicesApi,
  eventsApi,
  paymentsApi,
  publicEventsApi,
  publicPaymentsApi,
} from 'src/app/shared/constants/api.constants';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { Toast } from 'src/app/shared/enums/toast';
import {
  AuthService,
  HelpersService,
  HttpBaseService,
  ToastService,
} from '@evento-ng/libs';

@Component({
  selector: 'app-book-footer',
  templateUrl: './book-footer.component.html',
  styleUrls: ['./book-footer.component.scss'],
})
export class BookFooterComponent {
  tickets: any;
  showError = false;
  showErrorTime = false;
  showErrorCustomForm = false;
  showErrorinfoForm = false;
  invoiceId;
  showCartMobileFlag = false;
  @Input() eventId;
  @Input() customFormPageAppears = false;
  @Input() infoFormPageAppears = false;
  @Input() reviewPageAppears = false;
  @Input() backfromMobileCart;
  customFormObject: any;
  customFormFlag = false;
  isMobile = false;
  @Output() customForm = new EventEmitter<{}>();
  @Output() infoForm = new EventEmitter();
  @Output() review = new EventEmitter();
  @Output() showCartMobile = new EventEmitter(false);
  isSales = false;
  constructor(
    public ticketService: TicketService,
    public translateService: TranslateService,
    public router: Router,
    private recaptchaV3Service: ReCaptchaV3Service,
    private dataService: HttpBaseService,
    private authService: AuthService,
    private location: Location,
    private helpersService: HelpersService,
    private spinner: NgxSpinnerService,
    private toast: ToastService
  ) {
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
    if (this.router.url.includes('/sales/')) {
      this.isSales = true;
    }
  }

  ngOnInit() {
    this.getCustomForm();
  }

  ngOnChanges() {
    if (this.backfromMobileCart) {
      this.showCartMobileFlag = false;
    }
  }

  checkifAllValuesNull() {
    let valid = true;
    this.ticketService.bookTicket
      .getValue()
      ?.customForm?.values?.forEach((element) => {
        if (element.value) {
          console.log(element.value);
          valid = false;
        }
      });
    return valid;
  }

  payNow() {
    if (!this.isMobile) {
      if (
        this.ticketService.bookTicket.getValue()?.items?.length == 0 ||
        !this.ticketService.bookTicket.getValue()?.items
      ) {
        this.showError = true;
      } else if (!this.checkIfAllTimesSelected()) {
        this.showError = false;
        this.showErrorTime = true;
      } else if (
        this.customFormFlag &&
        !this.checkIfCustomFormAnswered() &&
        this.customFormPageAppears &&
        !this.infoFormPageAppears
      ) {
        this.showErrorCustomForm = true;
      } else if (this.customFormFlag && this.checkIfCustomFormAnswered()) {
        this.showErrorCustomForm = false;
        if (this.checkifAllValuesNull()) {
          this.customFormFlag = true;
          this.ticketService.updateBookTicket({
            customForm: null,
          });
        } else {
          this.submitAnswers();
        }
        this.customFormFlag = false;
        this.customFormPageAppears = false;
        this.showCartMobileFlag = false;
        this.review.emit();
        this.reviewPageAppears = true;
      } else if (
        !this.customFormPageAppears &&
        !this.infoFormPageAppears &&
        !this.reviewPageAppears
      ) {
        this.showError = false;
        this.showErrorTime = false;
        this.infoForm.emit();
        this.infoFormPageAppears = true;
      } else if (this.infoFormPageAppears && !this.checkIfInfoExists()) {
        this.showErrorinfoForm = true;
      } else if (this.infoFormPageAppears && this.checkIfInfoExists()) {
        this.showErrorinfoForm = false;
        this.infoFormPageAppears = false;
        this.showCartMobileFlag = false;
        if (this.customFormFlag) {
          this.customForm.emit(this.customFormObject);
          this.customFormPageAppears = true;
        } else {
          this.review.emit();
          this.reviewPageAppears = true;
        }
      } else if (
        this.customFormFlag &&
        !this.checkIfCustomFormAnswered() &&
        this.customFormPageAppears
      ) {
        this.showErrorCustomForm = true;
      } else if (this.reviewPageAppears) {
        this.ticketService.bookTicket.getValue().channel = 'ONLINE';
        this.createInvoice();
      }
    } else {
      this.payMobile();
    }
  }

  payMobile() {
    if (
      this.ticketService.bookTicket.getValue()?.items?.length == 0 ||
      !this.ticketService.bookTicket.getValue()?.items
    ) {
      this.showError = true;
    } else if (!this.showCartMobileFlag && !this.reviewPageAppears) {
      this.showError = false;
      this.showCartMobile.emit(true);
      this.showCartMobileFlag = true;
    } else if (!this.checkIfAllTimesSelected() && this.showCartMobileFlag) {
      this.showErrorTime = true;
    } else if (
      this.customFormFlag &&
      !this.checkIfCustomFormAnswered() &&
      this.customFormPageAppears &&
      !this.infoFormPageAppears
    ) {
      this.showErrorCustomForm = true;
    } else if (this.customFormFlag && this.checkIfCustomFormAnswered()) {
      this.showErrorCustomForm = false;
      if (this.checkifAllValuesNull()) {
        this.customFormFlag = true;
        this.ticketService.updateBookTicket({
          customForm: null,
        });
      } else {
        this.submitAnswers();
      }
      this.customFormFlag = false;
      this.customFormPageAppears = false;
      this.showCartMobileFlag = false;
      this.review.emit();
      this.reviewPageAppears = true;
    } else if (
      !this.infoFormPageAppears &&
      !this.reviewPageAppears &&
      !this.customFormPageAppears
    ) {
      this.showError = false;
      this.showErrorTime = false;
      this.infoForm.emit();
      this.infoFormPageAppears = true;
    } else if (this.infoFormPageAppears && !this.checkIfInfoExists()) {
      this.showErrorinfoForm = true;
    } else if (this.infoFormPageAppears && this.checkIfInfoExists()) {
      this.showErrorinfoForm = false;
      this.infoFormPageAppears = false;
      // this.showCartMobileFlag = false;
      if (this.customFormFlag) {
        this.customForm.emit(this.customFormObject);
        this.customFormPageAppears = true;
      } else {
        this.review.emit();
        this.reviewPageAppears = true;
      }
    } else if (this.reviewPageAppears) {
      this.ticketService.bookTicket.getValue().channel = 'ONLINE';
      this.createInvoice();
    }
  }

  submitAnswers() {
    const customForm = this.ticketService.bookTicket.getValue()?.customForm;
    delete customForm.isValid;
    customForm.values = customForm.values.filter((e) => {
      return e.value;
    });
    this.spinner.show();
    this.dataService
      .post(`${eventsApi}/${this.eventId}/forms/submit`, customForm)
      .subscribe((res) => {
        this.spinner.hide();
        this.ticketService.updateBookTicket({
          customFormSubmission: res.id,
        });
      });
  }

  checkIfAllTimesSelectedMobile() {
    let valid = true;
    this.ticketService.bookTicket.getValue()?.items?.map((item: any) => {
      if (item?.ticketSchedule?.timeSchedules?.length > 0 && !item?.time) {
        valid = false;
      }
    });
    return valid;
  }
  checkIfAllTimesSelected() {
    if (this.router.url.includes('sport')) return true;
    let valid = true;
    if (this.isMobile && !this.showCartMobileFlag) {
      return true;
    } else {
      this.ticketService.bookTicket.getValue()?.items?.map((item: any) => {
        if (item?.ticketSchedule?.timeSchedules?.length > 0 && !item?.time) {
          valid = false;
        }
      });
      return valid;
    }
  }

  checkIfCustomFormAnswered() {
    let valid = true;
    if (
      this.customFormObject.length > 0 &&
      !this.ticketService.bookTicket.getValue()?.customForm?.isValid
    ) {
      valid = false;
    }
    return valid;
  }

  checkIfInfoExists() {
    let valid = false;
    if (this.ticketService.bookTicket.getValue()?.info?.isValid) {
      valid = true;
    }
    return valid;
  }

  cancel() {
    this.ticketService.bookTicket.next(null);

    if (this.router.url.includes('sport')) {
      this.router.navigateByUrl('/matches/details/' + this.eventId);
    } else {
      {
        this.router.navigateByUrl('/event-details/' + this.eventId);
      }
    }
  }

  getCustomForm() {
    if (this.router.url.includes('sport')) {
      this.customFormFlag = false;
    } else {
      this.spinner.show();
      this.dataService
        .get(`${publicEventsApi}/${this.eventId}/custom-form`)
        .subscribe((res) => {
          this.spinner.hide();
          if (res.length == 0) {
            this.customFormFlag = false;
          } else {
            this.customFormObject = res;
            this.customFormFlag = true;
          }
        });
    }
  }

  createInvoiceSport() {
    this.spinner.show();
    const invoice = this.ticketService.bookTicket.getValue();
    this.recaptchaV3Service.execute('book').subscribe((token) => {
      const body: any = {
        channel: this.isSales ? 'ONLINE' : invoice.channel,
        matchId: this.eventId,
        teamId: invoice.items[0].ticket.team.id,
        firstName: invoice?.info?.firstName
          ? invoice.info.firstName
          : this.authService.user.getValue().firstName,
        lastName: invoice?.info?.lastName
          ? invoice.info.lastName
          : this.authService.user.getValue().lastName,
        email: invoice?.info?.email
          ? invoice.info.email
          : this.authService.user.getValue().email,
        mobile: invoice.info.mobile.number
          ? invoice.info.mobile.number
          : this.authService.user.getValue().mobile,
        mobileRegionCode: invoice.info?.mobile
          ? invoice?.info?.mobile?.countryCode
          : this.helpersService.extractCountryCode(
              this.authService.user.getValue().mobile
            ),
        ticketId: invoice.items[0].ticket.id,
        quantity: invoice.items[0].quantity,
        recaptcha: token,
      };
      if (invoice?.items?.[0]?.selectedSeats?.length > 0) {
        body.selectedSeats = invoice.items[0].selectedSeats;
        body.holdToken = JSON.parse(
          sessionStorage.getItem('seatsio')
        )?.holdToken;
      }
      this.dataService
        .post(`${sportInvoicesApi}/create`, body)
        .subscribe((result) => {
          this.spinner.hide();
          if (result.status === 'PAID') {
            this.ticketService.bookTicket.next(null);
            if (this.isSales) {
              this.location.back();
            } else {
              this.router.navigateByUrl('/matches/validate/' + result.id);
            }
          } else {
            if (this.isSales) {
              this.dataService
                .patch(`${paymentsApi}/${result.id}`, {
                  channel: result.channel,
                })
                .subscribe((res) => {
                  this.spinner.hide();
                  this.ticketService.bookTicket.next(null);
                  this.location.back();
                });
            } else {
              if (result?.payment?.id) {
                this.invoiceId = result.id;
                const paymentUrl = `${environment.paymentRoot}?id=${result?.payment?.id}`;
                window.open(paymentUrl, '_self');
              } else {
                this.toast.show(
                  'Error',
                  this.translateService.instant(
                    'A payment error occurred, please try again later'
                  ),
                  {
                    classname: Toast.error,
                  }
                );
              }
            }
          }
        });
    });
  }
  createInvoice() {
    if (this.router.url.includes('sport')) {
      this.createInvoiceSport();
      return;
    }
    this.spinner.show();
    const invoice = this.ticketService.bookTicket.getValue();
    this.recaptchaV3Service.execute('book').subscribe((token) => {
      const body = {
        channel: this.isSales ? 'ONLINE' : invoice.channel,
        customFormSubmission: invoice.customFormSubmission,
        event: this.eventId,
        items: invoice.items.map((item) => {
          delete item.ticketSchedule;
          return {
            ...item,
            ticket: item.ticket.id,
            schedule: item.schedule.id,
            time: item.time?.id,
          };
        }),
        metadata: {
          name: {
            first: invoice?.info?.firstName
              ? invoice.info.firstName
              : this.authService.user.getValue().firstName,
            last: invoice?.info?.lastName
              ? invoice.info.lastName
              : this.authService.user.getValue().lastName,
          },
          email: invoice?.info?.email
            ? invoice.info.email
            : this.authService.user.getValue().email,
          mobile: invoice.info.mobile.number
            ? invoice.info.mobile.number
            : this.authService.user.getValue().mobile,
          mobileRegionCode: invoice.info?.mobile
            ? invoice?.info?.mobile?.countryCode
            : this.helpersService.extractCountryCode(
                this.authService.user.getValue().mobile
              ),
        },
        recaptchaToken: token,
        promoCodeId: invoice.promoCodeId,
      };
      let api;
      if (this.isSales) {
        api = bookCustomTicketForEventUser;
      } else {
        api = publicPaymentsApi;
      }
      this.dataService.post(`${api}`, body).subscribe((result) => {
        this.spinner.hide();
        if (result.status === 'PAID') {
          this.ticketService.bookTicket.next(null);
          if (this.isSales) {
            this.location.back();
          } else {
            this.router.navigateByUrl('/validate/' + result.id);
          }
        } else {
          if (this.isSales) {
            this.dataService
              .patch(`${paymentsApi}/${result.id}`, { channel: result.channel })
              .subscribe((res) => {
                this.spinner.hide();
                this.ticketService.bookTicket.next(null);
                this.location.back();
              });
          } else {
            if (result?.payment?.id) {
              this.invoiceId = result.id;
              const paymentUrl = `${environment.paymentRoot}?id=${result?.payment?.id}`;
              window.open(paymentUrl, '_self');
            } else {
              this.toast.show(
                'Error',
                this.translateService.instant(
                  'A payment error occurred, please try again later'
                ),
                {
                  classname: Toast.error,
                }
              );
            }
          }
        }
      });
    });
  }
}
